import { render, staticRenderFns } from "./compensationMobilier.pug?vue&type=template&id=04c04c05&lang=pug&"
import script from "./compensationMobilier.js?vue&type=script&lang=js&"
export * from "./compensationMobilier.js?vue&type=script&lang=js&"
import style0 from "./compensationMobilier.scss?vue&type=style&index=0&lang=sccs&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c04c05')) {
      api.createRecord('04c04c05', component.options)
    } else {
      api.reload('04c04c05', component.options)
    }
    module.hot.accept("./compensationMobilier.pug?vue&type=template&id=04c04c05&lang=pug&", function () {
      api.rerender('04c04c05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Claim/views/compensationMobilier/index.vue"
export default component.exports